import React from "react";
import { Props_SnippetInstagram } from "./Instagram.props";
import SharedHeading from "../Shared/Heading/Heading";
import SnippetLink from "../Shared/Link/Link";

const SnippetInstagram = (props: Props_SnippetInstagram) => {
    const { heading, embed, links, repeatable_links } = props;

    const linkAlignmentClass = typeof links.alignment?.value === 'string'
        ? `snippet-instagram__link-container--${links.alignment.value}`
        : "";
    const iframeSrc = typeof embed.iframeSrc?.value === 'string' ? embed.iframeSrc.value : undefined;
    const scriptSrc = typeof embed.scriptSrc?.value === 'string' ? embed.scriptSrc.value : undefined;
    const headingLevel = heading.level?.value as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' || 'h2';

    return (
        <section className="snippet-instagram">
            <div className="snippet-instagram__container">
                <div className="snippet-instagram__text-section">
                    <SharedHeading
                        alignment={
                            heading.alignment?.value === "start" ||
                            heading.alignment?.value === "center" ||
                            heading.alignment?.value === "end"
                                ? heading.alignment.value
                                : undefined
                        }
                        className="snippet-instagram__heading"
                        visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
                        level={headingLevel}
                    >
                        {heading.text?.value}
                    </SharedHeading>
                </div>
                <div className="snippet-instagram__feed">
                    {iframeSrc && (
                        <iframe
                            src={iframeSrc}
                            scrolling="no"
                            className="lightwidget-widget"
                            title="snippet-instagram Feed"
                            style={{
                                width: "100%",
                                border: 0,
                                overflow: "hidden",
                                height: 804,
                            }}
                        />
                    )}
                </div>
                <div
                    className={`snippet-instagram__link-container ${linkAlignmentClass}`}
                >
                    {repeatable_links.map((link, index) => {
                        const { linkHref, linkTarget, linkText, linkStyle } =
                            link;

                        return (
                            <SnippetLink
                                key={index}
                                url={typeof linkHref?.value === 'string' ? linkHref.value : undefined}
                                openInNewTab={typeof linkTarget?.value === 'boolean' ? linkTarget.value : linkTarget?.value === "true"}
                                linkStyles={typeof linkStyle?.value === 'string' ? linkStyle.value : undefined}
                                className="snippet-instagram__link"
                            >
                                {typeof linkText?.value === 'string' ? linkText.value : ''}
                            </SnippetLink>
                        );
                    })}
                </div>
            </div>
            {scriptSrc && <script src={scriptSrc}></script>}
        </section>
    );
};

export default SnippetInstagram;
